/* ENGORI — Cookie-Zustimmung
   ---------------------------------------------------------------------------
   Eigener Zustimmungsdialog anstelle des Shopify-Standardbanners. Grund: Der
   Standardbanner erlaubt keinen eigenen Text und keine eigene Gestaltung.

   Die Entscheidung wird NICHT selbst gespeichert, sondern an Shopifys
   Customer-Privacy-API übergeben. Nur so greift sie auch dort, wo das Theme
   keinen Zugriff hat: Web Pixels, Kasse, Meta- und Google-Anbindung. Ein
   Banner, das nur ein eigenes Cookie setzt, sähe richtig aus und würde
   rechtlich nichts bewirken.

   ⚠️ Der Shopify-eigene Banner muss im Admin abgeschaltet sein
   (Einstellungen → Kundendatenschutz → Cookie-Banner), sonst erscheinen zwei.
*/
(function () {
  'use strict';

  var WURZEL = null;          // Dialogelement, erst bei Bedarf geholt
  var LETZTER_FOKUS = null;   // Element, das vor dem Öffnen den Fokus hatte
  var API_BEREIT = false;

  /* ---------------------------------------------------------------------
     Zuordnung der Schalter zu Shopifys vier Zustimmungssignalen
     --------------------------------------------------------------------- */
  function signaleAus(wahl) {
    return {
      analytics: !!wahl.statistik,
      marketing: !!wahl.werbung,
      preferences: !!wahl.komfort,
      // Weitergabe an Dritte hängt an der Werbezustimmung: Ohne Werbung gibt
      // es keinen Grund, Daten an Werbeplattformen weiterzureichen.
      sale_of_data: !!wahl.werbung
    };
  }

  /* ---------------------------------------------------------------------
     Shopify-API laden
     --------------------------------------------------------------------- */
  function apiLaden(fertig) {
    if (API_BEREIT) return fertig(true);
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      return fertig(false);
    }
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (fehler) {
        API_BEREIT = !fehler && !!(window.Shopify && window.Shopify.customerPrivacy);
        fertig(API_BEREIT);
      }
    );
  }

  /* Hat die Besucherin oder der Besucher schon entschieden?
     Shopify liefert je Signal 'yes', 'no' oder '' (noch keine Entscheidung).
     Bewusst NICHT über shouldShowBanner() geprüft: Das meldet nur, ob die
     Region im Admin für den Shopify-Banner eingerichtet ist — schaltet man
     diesen ab, kann die Antwort false werden und der eigene Dialog erschiene
     nie. Die Zustimmungswerte selbst sind davon unabhängig. */
  function schonEntschieden() {
    try {
      var c = window.Shopify.customerPrivacy.currentVisitorConsent();
      return !!(c && (c.analytics || c.marketing || c.preferences || c.sale_of_data));
    } catch (e) {
      return false;
    }
  }

  function aktuelleWahl() {
    try {
      var c = window.Shopify.customerPrivacy.currentVisitorConsent();
      return {
        komfort: c.preferences === 'yes',
        statistik: c.analytics === 'yes',
        werbung: c.marketing === 'yes'
      };
    } catch (e) {
      return { komfort: false, statistik: false, werbung: false };
    }
  }

  /* ---------------------------------------------------------------------
     Dialog öffnen und schließen
     --------------------------------------------------------------------- */
  function el() {
    if (!WURZEL) WURZEL = document.getElementById('eng-ck');
    return WURZEL;
  }

  function oeffnen(mitDetails) {
    var w = el();
    if (!w) return;

    /* Wie beim Bündel-Fenster direkt an body hängen: Liegt der Dialog in einem
       Vorfahren mit transform, filter oder eigener Zeichenebene, richtet sich
       position: fixed nicht mehr am Fenster aus, sondern an diesem Vorfahren. */
    if (w.parentNode !== document.body) document.body.appendChild(w);

    LETZTER_FOKUS = document.activeElement;
    schalterSetzen(aktuelleWahl());
    detailsZeigen(!!mitDetails);
    w.hidden = false;
    // Ein Bildaufbau dazwischen, sonst springt die Einblendung ohne Übergang.
    requestAnimationFrame(function () { w.classList.add('is-offen'); });

    var ziel = w.querySelector(mitDetails ? '[data-ck-speichern]' : '[data-ck-alle]');
    if (ziel) ziel.focus();
  }

  function schliessen() {
    var w = el();
    if (!w) return;
    w.classList.remove('is-offen');
    window.setTimeout(function () { w.hidden = true; }, 260);
    if (LETZTER_FOKUS && typeof LETZTER_FOKUS.focus === 'function') LETZTER_FOKUS.focus();
  }

  function detailsZeigen(an) {
    var w = el();
    if (!w) return;
    w.classList.toggle('eng-ck--details', an);
    var knopf = w.querySelector('[data-ck-details]');
    if (knopf) knopf.setAttribute('aria-expanded', an ? 'true' : 'false');
  }

  /* ---------------------------------------------------------------------
     Schalter lesen und setzen
     --------------------------------------------------------------------- */
  function schalterSetzen(wahl) {
    var w = el();
    if (!w) return;
    ['komfort', 'statistik', 'werbung'].forEach(function (name) {
      var feld = w.querySelector('[data-ck-feld="' + name + '"]');
      if (feld) feld.checked = !!wahl[name];
    });
  }

  function schalterLesen() {
    var w = el();
    var wahl = { komfort: false, statistik: false, werbung: false };
    if (!w) return wahl;
    ['komfort', 'statistik', 'werbung'].forEach(function (name) {
      var feld = w.querySelector('[data-ck-feld="' + name + '"]');
      wahl[name] = !!(feld && feld.checked);
    });
    return wahl;
  }

  /* ---------------------------------------------------------------------
     Entscheidung übernehmen
     --------------------------------------------------------------------- */
  function speichern(wahl) {
    if (!API_BEREIT) return schliessen();
    try {
      window.Shopify.customerPrivacy.setTrackingConsent(signaleAus(wahl), function () {
        schliessen();
      });
    } catch (e) {
      schliessen();
    }
    // Falls der Rückruf ausbleibt, schließt der Dialog trotzdem — sonst bliebe
    // er bei einer Netzstörung offen stehen.
    window.setTimeout(function () {
      var w = el();
      if (w && !w.hidden) schliessen();
    }, 1200);
  }

  /* ---------------------------------------------------------------------
     Bedienung
     --------------------------------------------------------------------- */
  function verdrahten() {
    var w = el();
    if (!w || w.dataset.ckBereit) return;
    w.dataset.ckBereit = '1';

    w.addEventListener('click', function (e) {
      if (e.target.closest('[data-ck-alle]')) {
        speichern({ komfort: true, statistik: true, werbung: true });
      } else if (e.target.closest('[data-ck-noetig]')) {
        speichern({ komfort: false, statistik: false, werbung: false });
      } else if (e.target.closest('[data-ck-details]')) {
        detailsZeigen(!w.classList.contains('eng-ck--details'));
      } else if (e.target.closest('[data-ck-speichern]')) {
        speichern(schalterLesen());
      }
    });

    /* Der Dialog lässt sich nicht mit Escape wegdrücken — es ist eine
       Entscheidung nötig, und ein Wegdrücken wäre keine. Escape klappt
       lediglich die Detailebene wieder ein. */
    w.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && w.classList.contains('eng-ck--details')) {
        e.stopPropagation();
        detailsZeigen(false);
      }
      if (e.key !== 'Tab') return;

      // Fokus im Dialog halten, solange er offen ist.
      var ziele = w.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]');
      if (!ziele.length) return;
      var erstes = ziele[0];
      var letztes = ziele[ziele.length - 1];
      if (e.shiftKey && document.activeElement === erstes) {
        e.preventDefault();
        letztes.focus();
      } else if (!e.shiftKey && document.activeElement === letztes) {
        e.preventDefault();
        erstes.focus();
      }
    });
  }

  /* ---------------------------------------------------------------------
     Nachträglicher Aufruf: Fußzeilen-Link und globale Funktion
     --------------------------------------------------------------------- */
  function nachtraeglichOeffnen(e) {
    if (e) e.preventDefault();
    apiLaden(function (bereit) {
      if (!bereit) return;
      verdrahten();
      oeffnen(true);
    });
  }

  window.engoriCookieEinstellungen = nachtraeglichOeffnen;

  // Jeder Link mit dieser Sprungmarke öffnet den Dialog — so lässt sich im
  // Shopify-Menü ohne Codeänderung ein Eintrag „Cookie-Einstellungen" anlegen.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="#cookie-einstellungen"], [data-cookie-einstellungen]');
    if (a) nachtraeglichOeffnen(e);
  });

  /* ---------------------------------------------------------------------
     Start
     --------------------------------------------------------------------- */
  function start() {
    verdrahten();
    apiLaden(function (bereit) {
      // Ohne API keine Anzeige: Ein Dialog, dessen Entscheidung nirgends
      // ankommt, wäre schlimmer als keiner.
      if (!bereit) return;
      if (!schonEntschieden()) oeffnen(false);
      fussleisteErgaenzen();
    });
  }

  /* Widerruf muss jederzeit möglich sein. Steht im Menü bereits ein passender
     Eintrag, wird hier nichts ergänzt — sonst stünde der Link doppelt. */
  function fussleisteErgaenzen() {
    if (document.querySelector('a[href$="#cookie-einstellungen"], [data-cookie-einstellungen]')) return;

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'eng-ck-widerruf';
    knopf.textContent = 'Cookie-Einstellungen';
    knopf.addEventListener('click', nachtraeglichOeffnen);

    /* [2026-08-30] Bevorzugt in die Rechtsliste der Fusszeile einreihen.
       Vorher lief der Selektor auf '.footer__content-bottom', das es in diesem
       Theme nicht gibt — der Knopf landete ueber den Rueckfall '.footer' ganz
       am Ende hinter allen Spalten und stand dort allein und linksbuendig.
       Die Liste ist ein <ul>, deshalb muss der Eintrag ein <li> sein und den
       gleichen Aufbau tragen wie die uebrigen Punkte (small.copyright__content). */
    var liste = document.querySelector(
      '.footer__copyright .policies, .footer__content-bottom .policies, .footer .policies'
    );
    if (liste) {
      var li = document.createElement('li');
      var small = document.createElement('small');
      small.className = 'copyright__content';
      small.appendChild(knopf);
      li.appendChild(small);
      liste.appendChild(li);
      return;
    }

    var ziel = document.querySelector('.footer__content-bottom, .footer');
    if (ziel) ziel.appendChild(knopf);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
